import type {ReactElement} from 'react';
import {useState} from 'react';
import type {TemplatesCardAnimatedPreviewProps} from './templates-card-animated-preview.types';
import styles from './templates-card-animated-preview.module.scss';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import {getAssetUrl} from '@Utils/s3.util';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';

export function TemplatesCardAnimatedPreview({isLoading, isSmall = false}: TemplatesCardAnimatedPreviewProps): ReactElement {
  const [numImagesLoaded, setNumImagesLoaded] = useState(0);
  const areImagesLoaded = numImagesLoaded >= 2;

  const onImageLoad = (): void => {
    setNumImagesLoaded((prevNum) => {
      return prevNum + 1;
    });
  };
  const getImgContainer = (imgURL: string): ReactElement => {
    return (
      <div className={`${styles.imgContainer} ${isSmall ? styles.small : ''} _position-relative ${areImagesLoaded ? styles.animated : ''}`}>
        <SkeletonBrick className={`_full-width _full-height ${styles.aiSkeleton} _position-absolute`} theme={SkeletonBrickTheme.AI_GRADIENT} />
        <img className={`_full-height _full-width ${styles.img}`} src={imgURL} alt="template-design" onLoad={onImageLoad} />
      </div>
    );
  };

  return (
    <div className={`${styles.mediaImgContainer} flex-center _full-width ${isSmall ? 'spacing-m-b-1' : 'spacing-m-b-2'}`}>
      {isLoading ? (
        <CircularProgressLoader size={LOADER_SIZE.DEFAULT} classes="_unmargin" color={LOADER_COLOR.AI_DARK} />
      ) : (
        <>
          {getImgContainer(getAssetUrl('event-wizard-ai-template-img-1.png'))}
          {getImgContainer(getAssetUrl('event-wizard-ai-template-img-2.png'))}
        </>
      )}
    </div>
  );
}
